import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import _ from 'lodash'

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
})

const { Types, Creators } = createActions({
  getPromotions: null,

  setPromotion: ['data'],
  setPromotionLoading: ['val'],

  deletePromotion: ['promotionId'],
  savePromotion: ['data'],
})

export const setPromotionReducer = (state, { data }) => state.set('data', data)

export const setPromotionLoadingReducer = (state, { val }) => state.set('loading', val)

export const deletePromotionReducer = (state, { promotionId }) =>
  state.set('data', _.omit(state.data, promotionId))

export const savePromotionReducer = (state, { data }) =>
  state.setIn(['data', data.key], data)

export const promotionReducer = createReducer(INITIAL_STATE, {
  [Types.SET_PROMOTION]: setPromotionReducer,
  [Types.SET_PROMOTION_LOADING]: setPromotionLoadingReducer,
  [Types.SAVE_PROMOTION]: savePromotionReducer,
  [Types.DELETE_PROMOTION]: deletePromotionReducer,
})

export const PromotionTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/promotionReducer.js